import { MS_PER_DAY, toUtcDate } from '@skytech/utils'

import type { AssetExtended } from '@/modules/admin/resources'
import type { LeasingAssetDetailsReturn } from '@/resources/leasing'

export const LEASE_END_WARNING_THRESHOLD_DAYS = 21

export const daysBeforeEndOfLease = (leaseEndDate: string): string => {
  if (!leaseEndDate) return '0'
  const today = new Date()
  const end = new Date(leaseEndDate)
  const diff = end.getTime() - today.getTime()
  const days = Math.ceil(diff / MS_PER_DAY)
  return String(days)
}

const LEASE_END_WARNING_STATUSES = ['REQ_SENT', 'USE']
export const getEndOfLeaseNearbyDateStatus = (
  asset?: AssetExtended,
  leasingData?: LeasingAssetDetailsReturn
) => {
  if (
    !asset ||
    !asset.isLeased ||
    !asset.leaseEnd ||
    !LEASE_END_WARNING_STATUSES.includes(asset?.status) ||
    !leasingData
  )
    return false

  // Check if employee has been notified and if the notification date is past or today
  // Or check if the lease end date is within the warning threshold
  const today = toUtcDate(new Date())
  const nearByDate = leasingData?.employeeLastNotificationDate
    ? toUtcDate(leasingData?.employeeLastNotificationDate)
    : null
  const isPastOrToday = nearByDate ? nearByDate <= today : false

  const leaseEndDate = toUtcDate(asset.leaseEnd)
  const daysUntilLeaseEnd = Math.ceil((leaseEndDate.getTime() - today.getTime()) / MS_PER_DAY)
  const isWithin21Days = daysUntilLeaseEnd <= LEASE_END_WARNING_THRESHOLD_DAYS

  return (
    asset?.isLeased &&
    LEASE_END_WARNING_STATUSES.includes(asset?.status) &&
    asset?.leaseEnd &&
    daysUntilLeaseEnd >= 0 &&
    (isPastOrToday || isWithin21Days)
  )
}

export const getDaysBeforeEndOfLease = (
  leaseEnd?: string | Date | null,
  baseDate?: string | Date | null
): number | null => {
  if (!leaseEnd || !baseDate) return null

  const leaseEndDate = toUtcDate(leaseEnd)
  const base = toUtcDate(baseDate)
  if (!leaseEndDate || !base) return null

  const diff = leaseEndDate.getTime() - base.getTime()
  const daysBeforeEOL = Math.ceil(diff / MS_PER_DAY)
  return daysBeforeEOL < 0 ? null : daysBeforeEOL
}

// TODO: Add helper functions for end of lease asset actions
